import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastresService } from './toaster.service';

const app = initializeApp(environment.firebase);

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSubject = new BehaviorSubject<any>(null);
  public notifications$ = this.notificationSubject.asObservable();

  constructor(private toastresService: ToastresService) {}

  sendNotification(notification: any) {
    this.notificationSubject.next(notification);
  }

  async requestPermission(): Promise<NotificationPermission> {
    try {
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        const messaging = getMessaging(app);
        const fcmToken = await getToken(messaging, {
          vapidKey: environment.firebase.vapidKey,
        });

        if (fcmToken) {
          localStorage.setItem(`${environment.prefix}-fcm-token`, fcmToken);
        }
      }

      return permission;
    } catch (error) {
      return 'denied';
    }
  }

  listenNotifications() {
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      const title = payload?.data?.title || 'New Notification';
      const body = payload?.data?.body || 'You have a new message.';
      this.toastresService.ShowInfo(body, title);
      this.sendNotification(payload?.data);
      this.playNotificationSound();
      this.updateTitle();
    });
  }

  private playNotificationSound() {
    const audio = new Audio('/assets/sounds/notification.mp3');
    audio.preload = 'auto';

    audio.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }

  private updateTitle() {
    const match = document.title.match(/\((\d+)\)/);
    let newCount = 1;

    if (match) {
      newCount = parseInt(match[1], 10) + 1;
    }

    const baseTitle = document.title.replace(/\(\d+\)\s*/, '');
    document.title = `(${newCount}) ${baseTitle}`;
  }
}
